<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-medal`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35.285 1a1 1 0 01.87 1.493l-4.576 8.079C38.301 13.499 43 20.2 43 28c0 10.493-8.507 19-19 19S5 38.493 5 28c0-7.8 4.7-14.501 11.421-17.428l-4.576-8.08A1 1 0 0112.715 1h22.57zM24 13c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zm10 15c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10zm-10-6a6 6 0 100 12 6 6 0 000-12zM17.862 5h12.276l-2.265 4h-7.746l-2.265-4z"/></svg>
</template>
<script>

export default {
  name: 'IconMedal',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
